import React from 'react';
import { Mail, Wrench } from 'lucide-react';

export default function ZoneMissingState() {
  return (
    <div className="p-8 rounded-2xl bg-white/[0.02] border border-white/[0.06]">
      <div className="flex items-start gap-5">
        <div className="w-12 h-12 rounded-xl bg-[#B0FC38]/[0.08] border border-[#B0FC38]/20 flex items-center justify-center shrink-0">
          <Wrench className="w-5 h-5 text-[#B0FC38]" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-medium text-white tracking-tight mb-2">
            Analytics aren't connected yet.
          </h3>
          <p className="text-sm text-gray-400 leading-relaxed max-w-xl">
            Your website's Cloudflare zone hasn't been linked to your portal account. Once NexSav finishes setup, traffic, uptime, and top-page data will appear here automatically.
          </p>
          <a
            href="mailto:support@nexsav.net?subject=Connect%20analytics%20for%20my%20portal"
            className="inline-flex items-center gap-1.5 mt-4 text-[13px] text-[#B0FC38] hover:text-white transition-colors"
          >
            <Mail className="w-3.5 h-3.5" />
            Email support@nexsav.net
          </a>
        </div>
      </div>
    </div>
  );
}
